/**
 * Page components that modules name in their manifest (`PageSpec::component("…")`, ADR-025 §2.3):
 * Cài đặt › Module › instance › Trang nghiệp vụ renders the component registered here under that
 * key. A module that brings its own page adds one line; a route page needs none
 * (`PageSpec::route`). A key the manifest names but this list lacks reads as "not available in
 * this version of the Control Center".
 */

import type { ComponentType } from 'react';
import { OteTestsPanel } from '../pages/integrations/OteTestsPanel';
import { VnPlacesPanel } from '../pages/integrations/VnPlacesPanel';

export const MODULE_PAGES: Readonly<Record<string, ComponentType>> = {
  // The OT&E certification tests of the registry connections.
  'registry.ote-tests': OteTestsPanel,
  // VNNIC's list of administrative places (Registrar API).
  'regulatory.vn-places': VnPlacesPanel,
};

/** The component registered under `key`, if any. */
export function modulePage(key: string): ComponentType | null {
  return Object.prototype.hasOwnProperty.call(MODULE_PAGES, key) ? (MODULE_PAGES[key] ?? null) : null;
}
